import type { Translation } from '../types.ts';
import type en from '../en/landing.ts';

export default {
    shared: {
        noWebsite: 'Kies eerst een actieve website.',
    },
    index: {
        title: "Landingspagina's",
        newDataset: 'Nieuwe dataset',
        emptyIntro: "Nog geen datasets voor landingspagina's. Een dataset bundelt één template + een slugpatroon + N rijen. Elke rij wordt één landingspagina.",
        emptyTemplates: 'Templates staan in de repository van je thema onder {path}. Ze worden automatisch gevonden zodra je een themaversie activeert.',
        createFirst: 'Maak je eerste dataset',
        columns: {
            template: 'Template',
            slugPattern: 'Slugpatroon',
            pages: "Pagina's",
        },
    },
    edit: {
        newTitle: "Nieuwe dataset voor landingspagina's",
        saveDataset: 'Dataset opslaan',
        created: 'Dataset aangemaakt',
        confirmDelete: "Dataset \"{name}\" verwijderen? | Dataset \"{name}\" en de landingspagina erin verwijderen? | Dataset \"{name}\" en alle {n} landingspagina's erin verwijderen?",
        confirmDeleteRow: 'Landingspagina "{slug}" verwijderen?',
        invalidRow: 'Ongeldige rij.',
        pickTemplate: 'Kies een template…',
        noVariables: 'geen variabelen',
        dataset: 'Dataset',
        namePlaceholder: 'Steden NL',
        template: 'Template',
        noTemplates: 'Geen landingstemplates gevonden in de actieve themaversie. Designers leveren die als {path} en activeren daarna een themaversie om ze hier beschikbaar te maken.',
        slugPattern: 'Slugpatroon',
        slugPatternPlaceholder: '/winkelen-in-{token}',
        slugPatternHint: 'Moet beginnen met /. Tokens: {slugified} (als slug) of {raw} (ongewijzigd).',
        metaTitlePattern: 'Patroon voor metatitel (optioneel)',
        metaTitlePatternPlaceholder: 'Winkelen in {city}: de lokale gids',
        metaTitlePatternHint: 'Dezelfde {token}-tokens. Gebruikt voor de {tag} van de pagina.',
        metaDescriptionPattern: 'Patroon voor metabeschrijving (optioneel)',
        metaDescriptionPatternPlaceholder: 'Ontdek de beste winkelstraten en winkels in {city}.',
        metaDescriptionPatternHint: 'Dezelfde {token}-tokens. Gebruikt voor {tag}.',
        pages: "Pagina's",
        importCsv: 'CSV importeren',
        noTemplateVars: 'Het gekozen template verwijst naar geen enkele {vars}, dus elke rij krijgt dezelfde slug en er kan er maar één bestaan. Voeg minstens één variabele toe aan het template.',
        addRowHeading: 'Rij toevoegen',
        addPage: 'Pagina toevoegen',
        seo: 'SEO',
        seoCustomTitle: 'Handgeschreven voor deze pagina',
        seoPatternTitle: 'Volgt het patroon van de dataset',
        seoCustom: 'Eigen',
        seoPattern: 'Patroon',
        deleteRow: 'Rij verwijderen',
        noPages: "Nog geen pagina's. Voeg er hierboven een toe of importeer een CSV.",
        noPattern: 'Geen patroon ingesteld',
        seoDialog: {
            title: 'SEO van de pagina',
            intro: "{slug}. Laat een veld leeg om het patroon van de dataset te volgen; dat staat grijs in het veld. Met de hand schrijven loont voor de pagina's die het verkeer trekken; de rest leest beter met het patroon dan met honderd varianten erop.",
            metaTitle: 'Metatitel',
            metaTitleHint: 'Leeg: gebruik het metatitelpatroon van de dataset.',
            metaDescription: 'Metabeschrijving',
            metaDescriptionHint: 'Leeg: gebruik het metabeschrijvingspatroon van de dataset. {token}-tokens werken hier ook.',
        },
        import: {
            title: 'CSV importeren',
            intro: 'De eerste regel is de kopregel met de kolomnamen. Die moet precies de variabelen bevatten die het template gebruikt: {vars}. Hij mag ook {metaTitle} en {metaDescription} bevatten, plus elke variabele waar de patronen van de dataset naar verwijzen zonder dat het template hem toont. Elke volgende regel is één landingspagina. De hele import wordt geweigerd als één rij niet door de validatie komt.',
            none: '(geen)',
            body: 'CSV-inhoud',
            replace: "Bestaande pagina's in deze dataset vervangen",
            replaceHint: 'Uit: toevoegen (een slug die al bestaat wordt geweigerd). Aan: eerst alle huidige rijen verwijderen en dan importeren.',
            perRowErrors: 'Fouten per rij',
            row: 'Rij {line}:',
            pasteFirst: 'Plak eerst de CSV-inhoud.',
            imported: "{n} landingspagina's geïmporteerd. | {n} landingspagina geïmporteerd. | {n} landingspagina's geïmporteerd.",
            failed: 'Importeren is mislukt.',
        },
    },
} satisfies Translation<typeof en>;
